import { postersEscapeSpacesAndApostrophes } from "./posters.js";
import { cacheGetCacheTime } from "./cache.js";
import { browserGetCookie } from "./browser.js";
import { i18nGetPageLanguage } from "./i18n.js";


const _mapsMappedRegions = ['Noguera', 'Urgell', 'Segrià', 'Pallars-Sobirà'];
const _mapsMappedLabels = ['Festa-Major', 'Falles', 'Astronomia'];
const _mapsVegueriaCachePrefix = "vegueriaRegions:";

let _mapsVegueriaRegions = null;
let _mapsRegionVegueria = null;
let _mapsVegueriaFetchPromise = null;

function mapsGetCurrentVegueria()
{
    if (typeof window !== "undefined" && typeof window.currentVegueria === "string")
    {
        return window.currentVegueria;
    }
    return "";
}

function mapsLocalizePath(path)
{
    if (i18nGetPageLanguage() !== "es")
    {
        return path;
    }
    if (path === "/")
    {
        return "/es/";
    }
    if (path.startsWith("/es/") || path === "/es")
    {
        return path;
    }
    return "/es" + path;
}

function mapsGetVegueriaStorageKey()
{
    const cacheTime = cacheGetCacheTime();
    const cacheSuffix = cacheTime || browserGetCookie("cacheTime") || "default";
    return _mapsVegueriaCachePrefix + cacheSuffix;
}

function mapsSetVegueriaRegions(payload)
{
    _mapsVegueriaRegions = payload;
    _mapsRegionVegueria = {};
    if (payload && typeof payload === "object")
    {
        Object.keys(payload).forEach((vegueria) =>
        {
            const regions = payload[vegueria];
            if (Array.isArray(regions))
            {
                regions.forEach((region) =>
                {
                    if (_mapsRegionVegueria[region] === undefined)
                    {
                        _mapsRegionVegueria[region] = vegueria;
                    }
                });
            }
        });
    }
}

function mapsPrefetchVegueries()
{
    if (_mapsVegueriaFetchPromise)
    {
        return _mapsVegueriaFetchPromise;
    }

    _mapsVegueriaFetchPromise = new Promise((resolve) =>
    {
        if (typeof window === "undefined")
        {
            resolve(false);
            return;
        }

        const storageKey = mapsGetVegueriaStorageKey();
        try
        {
            const cached = sessionStorage.getItem(storageKey);
            if (cached)
            {
                mapsSetVegueriaRegions(JSON.parse(cached));
                resolve(true);
                return;
            }
        } catch (err)
        {
            // Ignore storage failures.
        }

        let resource = "/vegueria";
        const cacheTime = cacheGetCacheTime() || browserGetCookie("cacheTime");
        if (cacheTime)
        {
            resource += "?cacheTime=" + cacheTime;
        }

        fetch(resource)
                .then((response) => response.json())
                .then((payload) =>
                {
                    mapsSetVegueriaRegions(payload);
                    try
                    {
                        sessionStorage.setItem(storageKey, JSON.stringify(payload));
                    } catch (err)
                    {
                        // Ignore storage failures.
                    }
                    resolve(true);
                })
                .catch(() =>
                {
                    resolve(false);
                });
    });

    return _mapsVegueriaFetchPromise;
}

function mapsGetVegueriaForRegion(region)
{
    if (!region)
    {
        return "";
    }
    if (_mapsRegionVegueria === null)
    {
        const storageKey = mapsGetVegueriaStorageKey();
        try
        {
            const cached = sessionStorage.getItem(storageKey);
            if (cached)
            {
                mapsSetVegueriaRegions(JSON.parse(cached));
            }
        } catch (err)
        {
            // Ignore storage failures.
        }
    }
    if (_mapsRegionVegueria && _mapsRegionVegueria[region])
    {
        return _mapsRegionVegueria[region];
    }
    return "";
}

function mapsGetRegionsForVegueria(vegueria)
{
    if (!vegueria)
    {
        return [];
    }
    if (_mapsVegueriaRegions === null)
    {
        const storageKey = mapsGetVegueriaStorageKey();
        try
        {
            const cached = sessionStorage.getItem(storageKey);
            if (cached)
            {
                mapsSetVegueriaRegions(JSON.parse(cached));
            }
        } catch (err)
        {
            // Ignore storage failures.
        }
    }
    if (_mapsVegueriaRegions && Array.isArray(_mapsVegueriaRegions[vegueria]))
    {
        return [..._mapsVegueriaRegions[vegueria]];
    }
    return [];
}


function mapsLabel(region, label)
{
    let aux = "";

    const vegueria = mapsGetVegueriaForRegion(region);
    if (vegueria)
    {
        aux = "/" + postersEscapeSpacesAndApostrophes(vegueria);
    } 

    const value = postersEscapeSpacesAndApostrophes(label);
    if (_mapsMappedLabels.includes(value))
    {
        return mapsLocalizePath(aux + '/' + value);
    }
    if (aux !== "")
    {
        return mapsLocalizePath(aux + '/' + value);
    }
    return mapsLocalizePath('/' + value);
}

function mapsTown(region, town)
{
    const value = postersEscapeSpacesAndApostrophes(town);
    // -------------------------------------------------------------------------
    let aux = "";

    if (region)
    {
        aux = "/" + postersEscapeSpacesAndApostrophes(region);
    }

    return mapsLocalizePath(aux + '/' + value);
}

function mapsRegion(region)
{
    const value = postersEscapeSpacesAndApostrophes(region);
//    if (_mapsMappedRegions.includes(value))
//    {
//        return ('/' + value);
//    }
    return mapsLocalizePath('/' + value);
}

export {
    mapsLabel,
    mapsTown,
    mapsRegion,
    mapsLocalizePath,
    mapsPrefetchVegueries,
    mapsGetVegueriaForRegion,
    mapsGetRegionsForVegueria
};


